// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import SocialTheme, { processSocialThemeArray } from "./SocialTheme";

export default interface SocialThemeInfo {
    layeredCount?: number;
    singleImageCount?: number;
    singleColorCount?: number;
    customCount?: number;
    layered?: SocialTheme[];
    singleImage?: SocialTheme[];
    singleColor?: SocialTheme[];
    custom?: SocialTheme[];
}

export function processSocialThemeInfo(value?: SocialThemeInfo): void {
  if (value) {
    processSocialThemeArray(value.layered);
    processSocialThemeArray(value.singleImage);
    processSocialThemeArray(value.singleColor);
    processSocialThemeArray(value.custom);
  }
}
